import { TEMPLATE_LAYOUT } from './constants';
import { getLayoutType } from './page';
import { getPhotoPlaceholders } from './placeholders';

export function getNumberOfCoverPhotos(template) {
  let numberOfCoverPhotos = 0;
  if (template.cover) {
    template.cover.forEach((page) => {
      numberOfCoverPhotos = Math.max(numberOfCoverPhotos, getPhotoPlaceholders(page).length);
    });
  }
  return numberOfCoverPhotos;
}

// `boundKey` selects minimumNumberOfPhotos / maximumNumberOfPhotos so the min and
// max getters share the per-page resolution instead of duplicating it.
function countTemplatePhotos(template, pageId, boundKey) {
  if (getLayoutType(template) === TEMPLATE_LAYOUT.PAGE && pageId.length > 0) {
    const page = template.pages.find((p) => p.id === pageId);
    if (page) {
      return getPhotoPlaceholders(page).length;
    }
  }
  return template.template[boundKey] || template.template.numberOfPhotos;
}

export function getMinimumNumberOfPhotos(template, pageId = '') {
  return countTemplatePhotos(template, pageId, 'minimumNumberOfPhotos') + (template.cover ? 1 : 0);
}

export function getMaximumNumberOfPhotos(template, pageId = '') {
  return countTemplatePhotos(template, pageId, 'maximumNumberOfPhotos') + (template.cover ? 1 : 0);
}

function countTemplatePages(template, boundKey, withCover) {
  let value = template.template[boundKey];
  if (withCover && template.cover) {
    value += 1;
  }
  return value;
}

export function getMinimumNumberOfPages(template, withCover = true) {
  return countTemplatePages(template, 'minimumNumberOfPages', withCover);
}

export function getMaximumNumberOfPages(template, withCover = true) {
  return countTemplatePages(template, 'maximumNumberOfPages', withCover);
}

export function getNumberOfAddablePages(template, numberOfPages) {
  return Math.max(0, getMaximumNumberOfPages(template) - numberOfPages);
}

export function getNumberOfPages(template, pages) {
  let numberOfPages = 0;

  pages.forEach((page) => {
    numberOfPages += 1;
    if (page.span) {
      numberOfPages += 1;
    }
  });

  return numberOfPages;
}

export function isNumberOfPagesValid(template, pages) {
  const numberOfPages = getNumberOfPages(template, pages);
  if (numberOfPages < getMinimumNumberOfPages(template)) {
    return false;
  }

  if (numberOfPages > getMaximumNumberOfPages(template)) {
    return false;
  }

  return true;
}
